module.exports = __webpack_public_path__ + "img/Picture9.d9e56517.jpg";